export default __webpack_public_path__ + "static/media/uploadLicense.23e3281f.svg";